/** @format */

import axios from 'axios';
import JsFileDownloader from 'js-file-downloader';

import { error as errorToast } from '../../Components/Toast';
// import {useHistory} from 'react-router-dom';
import {
  getStoredAuthToken,
  removeStoredAuthToken,
} from '../../utils/authToken';
import { baseApiUrl } from '../../utils/helper';

const defaults = {
  baseURL: baseApiUrl(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: getStoredAuthToken()
      ? `Bearer ${getStoredAuthToken()}`
      : undefined,
  },
  error: {
    code: 'INTERNAL_ERROR',
    message:
      'Something went wrong. Please check your internet connection or contact our support.',
    status: 503,
    data: {},
  },
};

const api = async (
  method,
  url,
  variables,
  fullfill,
  reject,
  fileUpload = false,
) => {
  let formData = {};
  if (fileUpload) {
    defaults['headers']['Content-Type'] = 'multipart/form-data';
    formData = new FormData();
    if (variables) {
      for (const property in variables) {
        formData.append(property, variables[property]);
      }
    }
  } else {
    defaults['headers']['Content-Type'] = 'application/json';
    formData = JSON.stringify(variables);
  }
  await axios({
    headers: defaults.headers,
    baseURL: defaults.baseURL,
    url: url,
    method,
    params: method !== 'post' && method !== 'put' ? variables : undefined,
    data: method !== 'get' ? formData : undefined,
  }).then(
    (response) => {
      fullfill(response);
    },
    (error) => {
      if (error.response) {
        const { status, data } = error.response;
        const payload = { status, data };

        if (status === 401) {
          const onLoginPage = window.location.pathname.startsWith('/login');
          if (!onLoginPage) {
            resetToken();
          }
        } else if (status === 403) {
          window.location.href = '/403';
          return;
        }

        reject(payload);
      } else {
        reject(defaults.error);
      }
    },
  );
};

const resetToken = () => {
  removeStoredAuthToken();
  errorToast('مشخصات ورود اشتباه است');
  let getUrl = window.location;
  let baseUrl = getUrl.protocol + '//' + getUrl.host;
  let backUrl = `?back=${getUrl.pathname}`;
  window.location.replace(baseUrl + '/login' + backUrl);
};

const batchGet = async (urls) => {
  let data = [];
  for (let i = 0; i < urls.length; i += 4) {
    //Chunk request to four request
    let chunkUrls = urls.slice(i, i + 4);

    try {
      const res = await Promise.all(
        chunkUrls.map((url) => axios.get(url, { headers: defaults.headers() })),
      );

      data = [...data, ...res.map((res) => res.data)];
    } catch (error) {
      throw Error(error);
    }
  }

  return data;
};

const downloadFile = (path) => {
  new JsFileDownloader({
    url: path,
    headers: [
      {
        name: 'Authorization',
        value: getStoredAuthToken()
          ? `Bearer ${getStoredAuthToken()}`
          : undefined,
      },
    ],
  })
    .then(function () {
      // Called when download ended
    })
    .catch(function (error) {
      // Called when an error occurred
    });
};

let ApiExport = {
  get: (url, variables, fullfill, reject) =>
    api('get', url, variables, fullfill, reject),
  post: (url, variables, fullfill, reject, fileUpload) =>
    api('post', url, variables, fullfill, reject, fileUpload),
  put: (url, variables, fullfill, reject, fileUpload) =>
    api('put', url, variables, fullfill, reject, fileUpload),
  delete: (url, variables, fullfill, reject) =>
    api('delete', url, variables, fullfill, reject),
  batchGet: (urls) => batchGet(urls),
  downloadFile: (path) => downloadFile(path),
};

export default ApiExport;
